// extracted by mini-css-extract-plugin
export default {"banner":"SiteBanner_banner__Fh6I8","message":"SiteBanner_message__QzuPA","close":"SiteBanner_close__6dut-"};